export const PRODUCT_AUTO_LOGIN_ROUTE = 'einzahlungsbonus';

export function isProductAutoLoginRequested(
  searchParams: URLSearchParams,
  pathname: string,
  authProvider: string,
): boolean {
  return authProvider === 'tipico' && (searchParams.has('auto') || pathname.includes(PRODUCT_AUTO_LOGIN_ROUTE));
}
